var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Overlay',_vm._g({staticClass:"modal-mobile"},_vm.$listeners),[_c('ModalPlain',[_vm._t("default")],2),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }